import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import {
  CATALOG_ACTOR_AUDIOBOOKS_SET_DATA,
  CATALOG_ACTOR_AUDIOBOOKS_RESET_DATA,
} from 'rebook/apps/catalog/constants';
import truncateChars from 'rebook/apps/utils/text/truncateChars';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';


export const fetchInitialData = (match, location = {}, actor = null) => {
  return async(dispatch, getState) => {
    const { ssr, actorAudiobookList: currentState } = getState();
    const orderBy = get(ssr, 'query.o', 'popular');
    const pageNumber = ssr.query && ssr.query.page
      ? parseInt(ssr.query.page, 10)
      : 1;
    const actorSlug = get(match, 'params.actorSlug', '');

    let newState = {
      actorSlug,
      pageNumber,
      orderBy,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }

    if (currentState) {
      newState = {
        ...newState,
        ...currentState,
      };
    }

    if (actor) {
      newState.actor = actor;
    }

    dispatch(setData(newState));
    if (!get(newState, 'actor.id', false)) {
      await dispatch(fetchActor(newState.actorSlug));
    }

    if (get(newState, 'actor.id', false)) {
      await dispatch(fetchAudiobookList({ actor: newState.actor, pageNumber: newState.pageNumber }));
    }
  };
};

export const fetchAudiobookList = (params = {}) => {
  return async(dispatch, getState) => {
    const { ssr, actorAudiobookList } = getState();
    const mergedState = { ...actorAudiobookList, ...params };
    const { actor, paginateBy, orderBy } = mergedState;
    let pageNumber = mergedState.pageNumber || 1;

    let queryParams = {
      offset: (pageNumber - 1) * paginateBy,
      limit: paginateBy,
      o: orderBy,
      type: 'audio',
      actors: actor.id,
      author_weight__gte: 0,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/books/?${qs}`;

    return await (
      fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
        .then(({ data }) => {
          const lastPageNumber = Math.ceil(data.meta.total_count / paginateBy);
          dispatch(setData({
            audiobookList: data.objects,
            totalBookCount: data.meta.total_count,
            pageNumber,
            orderBy,
            lastPageNumber,
          }));
        })
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load audiobook list data due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load audiobook list data due to server error');
        })
    );
  };
};

export const fetchActor = (actorSlug) => {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/actors/s-${actorSlug}/`;
    return await (
      fetchQuery(url, { headers: ssr.headers })
        .then(({ data }) => {
          dispatch(setData({
            actor: data,
          }));
        })
        .catch(({ data, resp, error }) => {
          if (resp.status === 404) {
            dispatch(Error404Actions.show());
          }
          Raven.captureMessage('failed to load actor data due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load actor data due to server error');
        })
    );
  };
};

const getFirstBookNames = (bookList) => {
  let result = '';

  if (!bookList) {
    return result;
  }

  for (let i = 0; i < bookList.length; i++) {
    result += ` ${bookList[i].name}.`;
  }

  return result;
};

export const setSeoMeta = () => {
  return (dispatch, getState) => {
    const { booksPerSubscriptionCounter, actorAudiobookList } = getState();
    const { actor, audiobookList, pageNumber } = actorAudiobookList;
    const bookNamesString = truncateChars(getFirstBookNames(audiobookList), 150);
    const desktopUrl = `https://${BASE_HOST}/actor/${actor.slug}/`;

    let title = `${actor.cover_name} — слушать онлайн все аудиокниги 🎧 в исполнении чтеца на Mybook`;
    let description = `${actor.cover_name} — слушать онлайн все аудиокниги 🎧 в исполнении чтеца на Mybook. ` +
      `Более ${booksPerSubscriptionCounter.audio} аудиокниг разных жанров и тем. ` +
      `Удобное приложение для Android и IOS.${bookNamesString}`;
    const ogTags = [
      { name: 'title', value: title },
      { name: 'description', value: description },
    ];
    dispatch(SeoActions.setData({
      canonicalUrl: desktopUrl,
      title,
      description,
      ogTags,
      pageNumber,
    }));
  };
};

export const setData = (payload) => {
  return (dispatch) => {
    const { actor } = payload;
    dispatch({
      type: CATALOG_ACTOR_AUDIOBOOKS_SET_DATA,
      payload,
    });
    if (actor) {
      dispatch(setSeoMeta());
    }
  };
};

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: CATALOG_ACTOR_AUDIOBOOKS_RESET_DATA,
    });
  };
}
